//@ts-ignore
import { tw } from "@careinfo/tailwind";
import {
  Control,
  FieldErrors,
  UseFormClearErrors,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
} from "react-hook-form";
import APIS from "../../constant/Endpoint";
import { IAuthorSchema } from "../../utils/validationSchema";
import ComboboxInput from "../Reusable/ComboboxInput";
import ImageField from "../Reusable/ImageField";
import { RichTextEditor } from "../Reusable/RichTextEditor";
import TextField from "../Reusable/TextField";

interface Props {
  register: UseFormRegister<IAuthorSchema>;
  setValue: UseFormSetValue<IAuthorSchema>;
  getValues: UseFormGetValues<IAuthorSchema>;
  errors: FieldErrors<IAuthorSchema>;
  clearErrors?: UseFormClearErrors<IAuthorSchema>;
  control: Control<IAuthorSchema>;
}

const AuthorForm = ({
  register,
  errors,
  setValue,
  getValues,
  clearErrors,
  control,
}: Props) => {
  return (
    <>
      <div
        className={tw`grid grid-cols-2 gap-4`}
        style={{
          gridTemplateColumns: "1fr 1.8fr",
        }}
      >
        <div className={tw`border-r px-4`}>
          <ComboboxInput
            url={APIS.USER}
            queryKey={"user"}
            errors={errors?.user}
            name={"user"}
            label={"User"}
            setValue={setValue}
            placeholder={"Enter full name"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <TextField
            placeholder="Enter a name to display in blogs"
            type="text"
            label="Display Name"
            register={register("display_name", {
              required: "Display Name is required",
            })}
            errors={errors.display_name}
          />
          <ImageField
            label="Preview Image"
            control={control}
            name="preview_image"
          />
        </div>
        <RichTextEditor
          register={register("summery")}
          setValue={setValue}
          errors={errors.summery}
          label="Summary"
          registeredKey="summery"
          control={control}
          name="summery"
        />
      </div>
    </>
  );
};

export default AuthorForm;
